<app-section-quick-actions section="spirit" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Traveling Spirits</h1>
</header>

<div class="atmos-card atmos-ts__grid-card">
  <ag-grid-angular
    [rowData]="rowData"
    [columnDefs]="colDefs"
    [theme]="theme"
    [getRowHeight]="getRowHeight"
    [suppressDragLeaveHidesColumns]="true"
    (gridReady)="onGridReady($event)" />
</div>
